import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import hometownImageDesktopWebp from './images/hometown-desktop.webp';
import hometownImageMobileWebp from './images/hometown-mobile.webp';
// base urls
import { nmFoundationBaseUrl } from '../../../../../utils/unsecuredLinks';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-communities-inclusive-hometown'
    themeType='lightTheme'
    backgroundVariant='lightA'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent={false}
    // content
    subHeadingText={<>Supporting our hometown</>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          We contribute to community partners and raise funds for community giving campaigns to help make our hometown an even better place to live, work, and visit. Through our efforts, we&#39;re making Milwaukee a vibrant community and destination.
        </Typography>
        <Link
          id='sustainability-impact-communities-inclusive-hometown-link'
          variant='buttonLinkSecondary'
          linkUrl={`${nmFoundationBaseUrl}/prominent-destinations/`}
          ariaLabel='Find out more about how we are increasing cultural attractions.'
          isInternalPdf>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='Volunteers packing food items at a pantry with shelves'
    imageSrcDefault={hometownImageDesktopWebp}
    imageSrcMobile={hometownImageMobileWebp}
  />
);
